import { Button, Modal } from 'react-bootstrap';
import { IWatrRequest } from '@nkr/models/index';
import ClaimHistory from '../claim-history';

interface IProps {
    show: boolean;
    data: IWatrRequest;
    onClose: () => void;
}

const ClaimHistoryModal = (props: IProps) => {
    if (!props.data) {
        return null;
    }

    return (
        <Modal
            backdrop="static"
            show={props.show}
            onHide={props.onClose}
            bsSize="large"
            className="modal-vertical-center"
            style={{ display: 'flex', alignItems: 'center' }}
        >
            <Modal.Header closeButton>
                <Modal.Title>Claim History</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <ClaimHistory data={props.data} travels={props.data.requestTravels || []} />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ClaimHistoryModal;
